
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import ProfileLayout from '@Components/Layout/profile';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import { Li, P, Title, Ul } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import useTranslation from 'next-translate/useTranslation';

type Props = {};

const ReturnPolicy = ({}: Props) => {
  const { t } = useTranslation('common');
  return (
    <ProfileLayout seoData={{ title: t('return-policy') }} hideSideBar={true}>
      <Wrapper>
        <div dir="auto">
          <Title>سياسة الاسترجاع</Title>
          <Ul>
            <Li>يُسمح للعميل بتقديم طلب استرجاع في خلال أسبوعين من التسليم</Li>
            <Li>يُسمح فقط بإعادة القطع إذا كانت في حالتها الأصلية عند استلامها</Li>
            <Li>يجب توفر إيصال عملية الشراء عند الاسترجاع</Li>
          </Ul>
          <Title>أمثلة:</Title>
          <Ul>
            <Li>تم إرسال منتج خطئ للعميل</Li>
            <Li>المنتج به عطل عند الاستلام وقبل مغادرة المندوب.</Li>
            <Li>المنتج أصابه عطل في عملية النقل.</Li>
            <Li>لم يتم إرسال القطعة في الوقت المتفق عليه.</Li>
          </Ul>
          <Title>غير قابلة للاسترجاع</Title>
          <P>
            وما هو جدير بالذكر أن هناك منتجات غير قابلة للإرجاع ومن المنتجات غير قابلة للارجاع وتوفر القائمة أدناه قائمة
            من البضائع المصنفة على أنها غير قابلة للإرجاع وفقًا لسياسة الارتجاع الخاصة بنا.
          </P>
          <P>
            يتم رفض إرجاع بعض الأجزاء لأنها تتشارك في نفس تصنيف نظائرها: مثال: أجزاء الكهرباء. هذه القائمة تمثل غالبية
            الأصناف وليست كلها. قد تضاف بعض الأصناف لهذه القائمة في حالة مشاركيتها لنفس الصنف
          </P>

          <Ul>
            <Li>-سويتشات 4WD</Li>
            <Li>-حساسات ABS </Li>
            <Li>-سويتشات تكييف ساخن وبارد</Li>
            <Li>-صمام دخول الهواء</Li>
            <Li>-حساسات درجة حرارة الهواء</Li>
            <Li>-مقاومات مروحة بلاور تكييف</Li>
            <Li>-سويتشات مروحة بلاور</Li>
            <Li>-حساسات كرنك</Li>
            <Li>-حساسات كامة </Li>
            <Li>-الكربراتير</Li>
            <Li>-سويتش ذراع الانوار</Li>
            <Li>-كنترولات السيارة</Li>
            <Li>-حساسات درجة حرارة المحرك</Li>
            <Li>-سويتشات مثبت السرعة </Li>
            <Li>-ريلاي</Li>
            <Li>-مفتاح الانتظار</Li>
            <Li>-قطع غيار الاسبراتير</Li>
            <Li>-الاسبراتير</Li>
            <Li>-سويتشات قفل باب السيارة</Li>
            <Li>-وحدات سنتر لوك</Li>
            <Li>-صمامات وحساسات EGR </Li>
            <Li>-حساسات قياس مستويات السوائل</Li>
            <Li>-رشاشات المحرك</Li>
            <Li>-منظم ضغط الوقود</Li>
            <Li>-اكسسوارات واجزاء طلمبة البنزين</Li>
            <Li>-طلمبة البنزين</Li>
            <Li>-جوانات</Li>
            <Li>-سويتشات نور عالي </Li>
            <Li>-صمام الايدل</Li>
            <Li>-موبينة المحرك</Li>
            <Li>-مشط موبينة اشعال</Li>
            <Li>-صينية اسبراتير</Li>
            <Li>-ذراع اشارة</Li>
          </Ul>

          <Ul>
            <Li>-سويتشات كونتاكت</Li>
            <Li>- حساسات اكصدام ايرباج</Li>
            <Li>- حساسات الصفع</Li>
            <Li>- موصلات الاضاءة</Li>
            <Li>- اسطوانة مفاتيح الابواب</Li>
            <Li>- حساسات ايرماس MAF</Li>
            <Li>-حساسات منفولد سحب MAP</Li>
            <Li>- سويتشات مرايات</Li>
            <Li>-سويتشات لوك الفتيس</Li>
            <Li>-سويتشات ضغط زيت</Li>
            <Li>-حساسات شكمان</Li>
            <Li>- حساسات دواسة البنزين</Li>
            <Li>- ابلاتين وكوندنسر</Li>
            <Li>- سويتشات مفتاح زجاج</Li>
            <Li>-بلف بخار البنزين</Li>
            <Li>- اجزاء طلمبة هواء المحرك</Li>
            <Li>-طلمبة هواء المحرك</Li>
            <Li>-حساسات السرعة</Li>
            <Li>- حساسات طارة الدركسيون</Li>
            <Li>- ماكينة استوب</Li>
            <Li>-موصلات</Li>
            <Li>- سويتشات درجة حرارة المحرك</Li>
            <Li>- بوابة الانجكشن</Li>
            <Li>-حساسات بوابة الانجكشن TPS</Li>
            <Li>- حساسات الكاوتش TPMS</Li>
            <Li>- اجزاء تربو</Li>
            <Li>-حساس تربو</Li>
            <Li>- صمامات تربو</Li>
            <Li>-سويتشات الاشارات</Li>
            <Li>-طلمبة فاكيوم</Li>
            <Li>-صمامات VVT</Li>
            <Li>-كتاوت دينامو</Li>
            <Li>- تربو</Li>
          </Ul>
        </div>
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default ReturnPolicy;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/return-policy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  